import SpriteSvg from './js/sprite-svg';

export {
    SpriteSvg,
};
